// Side-effect module: registers the `planChange` namespace into i18next.
// Imported by PlanChangeConfirm so the strings ship with it. Same
// ordering-safe pattern as registerCreatorCodeI18n.ts.
import i18n from "../i18n";
import planChange from "./planChange";

for (const [code, data] of Object.entries(planChange)) {
  i18n.addResourceBundle(
    code,
    "translation",
    { planChange: data },
    true,
    true,
  );
}
